(function () {
  if (customElements.get('beard-oil-purchase-stack')) return;

  customElements.define(
    'beard-oil-purchase-stack',
    class BeardOilPurchaseStack extends HTMLElement {
      constructor() {
        super();

        this.mode = 'single';
        this.variantMap = new Map();
        this.riyalSymbolMarkup = '';
        this.taxIndicatorMarkup = '';
        this.wardrobeVariantId = Number(this.dataset.wardrobeVariantId || 0);

        const variantsNode = this.querySelector('[data-purchase-variants]');
        if (variantsNode) {
          try {
            const variants = JSON.parse(variantsNode.textContent);
            variants.forEach((variant) => {
              this.variantMap.set(String(variant.id), variant);
            });
          } catch (error) {
            console.error('Unable to parse Beard Oil purchase variants', error);
          }
        }

        const riyalSymbolTemplate = this.querySelector('[data-riyal-symbol-template]');
        const taxIndicatorTemplate = this.querySelector('[data-tax-indicator-template]');
        this.riyalSymbolMarkup = riyalSymbolTemplate?.innerHTML.trim() || '';
        this.taxIndicatorMarkup = taxIndicatorTemplate?.innerHTML.trim() || '';
      }

      connectedCallback() {
        if (this.dataset.bound === 'true') return;

        this.productRoot = this.closest('[id^="MainProduct-"]');
        this.productInfo = this.closest('.product__info-container');
        this.variantPicker = this.productRoot?.querySelector('variant-selects');
        this.optionContainer = this.getOptionContainer();
        this.form = document.getElementById(this.dataset.productFormId);
        this.productForm = this.form?.closest('product-form');
        this.submitButton = this.form?.querySelector('[name="add"]');
        this.submitLabel = this.submitButton?.querySelector('span');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.statusNode = this.querySelector('[data-purchase-status]');
        this.trioPanel = this.querySelector('[data-trio-panel]');
        this.trioSelects = Array.from(this.querySelectorAll('[data-trio-variant]'));

        if (!this.productRoot || !this.productInfo || !this.optionContainer || !this.form || !this.submitButton) {
          return;
        }

        this.dataset.bound = 'true';
        this.hidden = false;
        this.productInfo.classList.add('is-beard-oil-purchase-stack-bound');

        this.querySelectorAll('[data-scent-option]').forEach((button) => {
          button.addEventListener('click', () => this.selectScent(button));
        });

        this.querySelectorAll('[data-purchase-plan]').forEach((input) => {
          input.addEventListener('change', () => this.setMode(input.value));
        });

        this.trioSelects.forEach((select) => {
          select.addEventListener('change', () => this.updatePrices());
        });

        this.form.addEventListener('submit', (event) => this.handleSubmit(event), true);
        this.productRoot.addEventListener('change', (event) => {
          if (!event.target.closest('variant-selects')) return;
          window.requestAnimationFrame(() => this.syncCurrentVariant());
        });

        this.submitObserver = new MutationObserver(() => this.syncSubmitLabel());
        this.submitObserver.observe(this.submitButton, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.setDistinctTrioDefaults();
        this.syncCurrentVariant();
        this.setMode('single');
      }

      disconnectedCallback() {
        this.submitObserver?.disconnect();
      }

      getOptionContainer() {
        if (!this.variantPicker) return null;
        return Array.from(this.variantPicker.children).find((child) =>
          child.classList.contains('product-form__input')
        );
      }

      getSelectedOption() {
        const checked = this.optionContainer?.querySelector('input[type="radio"]:checked');
        const select = this.optionContainer?.querySelector('select');
        return checked?.value || select?.value || '';
      }

      getVariantByOption(optionValue) {
        return Array.from(this.variantMap.values()).find((variant) => variant.option === optionValue);
      }

      getCurrentVariant() {
        const hiddenVariantId = this.form?.querySelector('[name="id"]')?.value;
        return this.variantMap.get(String(hiddenVariantId)) || this.getVariantByOption(this.getSelectedOption());
      }

      selectScent(button) {
        if (!button || button.disabled) return;

        const optionValue = button.dataset.scentOption;
        const radio = Array.from(this.optionContainer.querySelectorAll('input[type="radio"]'))
          .find((input) => input.value === optionValue);
        const select = this.optionContainer.querySelector('select');

        if (radio) {
          radio.click();
        } else if (select) {
          select.value = optionValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        this.syncCurrentVariant(button.dataset.scentDisplayName);
        window.requestAnimationFrame(() => this.syncCurrentVariant(button.dataset.scentDisplayName));
      }

      syncCurrentVariant(preferredDisplayName) {
        const selectedOption = this.getSelectedOption();
        const variant = this.getVariantByOption(selectedOption) || this.getCurrentVariant();
        if (!variant) return;

        this.querySelectorAll('[data-scent-option]').forEach((button) => {
          const isSelected = button.dataset.scentOption === variant.option;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', String(isSelected));
        });

        const selectedButton = Array.from(this.querySelectorAll('[data-scent-option]'))
          .find((button) => button.dataset.scentOption === variant.option);
        const displayName = preferredDisplayName
          || selectedButton?.dataset.scentDisplayName
          || variant.displayName
          || variant.option;

        const currentScent = this.querySelector('[data-current-scent]');
        const trioPrimary = this.querySelector('[data-trio-primary]');
        if (currentScent) currentScent.textContent = displayName;
        if (trioPrimary) trioPrimary.textContent = displayName;

        this.normalizeTrioDefaults(variant.id);
        this.updatePrices();
        this.syncSubmitLabel();
      }

      setDistinctTrioDefaults() {
        const availableVariants = Array.from(this.variantMap.values()).filter((variant) => variant.available);
        if (!availableVariants.length) return;

        const currentId = String(this.getCurrentVariant()?.id || '');
        const remaining = availableVariants.filter((variant) => String(variant.id) !== currentId);

        this.trioSelects.forEach((select, index) => {
          const preferred = remaining[index] || availableVariants[index] || availableVariants[0];
          if (preferred) select.value = String(preferred.id);
        });
      }

      normalizeTrioDefaults(primaryVariantId) {
        const availableVariants = Array.from(this.variantMap.values()).filter((variant) => variant.available);
        const usedIds = new Set([String(primaryVariantId)]);

        this.trioSelects.forEach((select) => {
          const currentId = String(select.value);
          if (usedIds.has(currentId)) {
            const replacement = availableVariants.find((variant) => !usedIds.has(String(variant.id)));
            if (replacement) select.value = String(replacement.id);
          }
          usedIds.add(String(select.value));
        });
      }

      setMode(mode) {
        this.mode = mode === 'trio' ? 'trio' : 'single';

        this.querySelectorAll('[data-purchase-plan]').forEach((input) => {
          const isSelected = input.value === this.mode;
          input.checked = isSelected;
          input.closest('.beard-oil-purchase-stack__plan')?.classList.toggle('is-selected', isSelected);
        });

        if (this.trioPanel) this.trioPanel.hidden = this.mode !== 'trio';
        this.setStatus('');
        this.updatePrices();
        this.syncSubmitLabel();
      }

      syncSubmitLabel() {
        if (!this.submitLabel || this.submitButton?.disabled) return;

        const desiredLabel = this.mode === 'trio'
          ? this.dataset.trioSubmitLabel
          : this.dataset.singleSubmitLabel;

        if (desiredLabel && this.submitLabel.textContent.trim() !== desiredLabel) {
          this.submitLabel.textContent = desiredLabel;
        }
      }

      updatePrices() {
        const primary = this.getVariantByOption(this.getSelectedOption()) || this.getCurrentVariant();
        if (!primary) return;

        const singlePrice = this.querySelector('[data-single-price]');
        const trioPrice = this.querySelector('[data-trio-price]');

        if (singlePrice) {
          singlePrice.innerHTML = this.formatMoneyMarkup(Number(primary.displayPrice), true);
        }

        const trioTotal = Number(this.dataset.trioPrice || 0);
        if (trioPrice) trioPrice.innerHTML = this.formatMoneyMarkup(trioTotal, true);
      }

      formatMoneyMarkup(amountInCents, includeTaxIndicator = false) {
        const locale = this.dataset.locale || 'en-SA';
        const currency = this.dataset.currency || 'SAR';
        const safeAmount = Math.round(Number(amountInCents || 0)) / 100;
        const amount = new Intl.NumberFormat(locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(safeAmount);

        if (currency === 'SAR') {
          const currencyMarkup = this.riyalSymbolMarkup
            ? `<span class="sar-price__symbol" aria-hidden="true">${this.riyalSymbolMarkup}</span>`
            : '<span class="sar-price__code">SAR</span>';
          const taxMarkup = includeTaxIndicator ? this.taxIndicatorMarkup : '';

          return `<span class="sar-price">${currencyMarkup}<span class="sar-price__amount">${amount}</span></span>${taxMarkup}`;
        }

        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        }).format(safeAmount);
      }

      setStatus(message, isError = false) {
        if (!this.statusNode) return;
        this.statusNode.textContent = message || '';
        this.statusNode.classList.toggle('is-error', isError);
      }

      setLoading(isLoading) {
        const spinner = this.submitButton?.querySelector('.loading__spinner');
        this.submitButton?.classList.toggle('loading', isLoading);
        spinner?.classList.toggle('hidden', !isLoading);

        if (isLoading) {
          this.submitButton?.setAttribute('aria-disabled', 'true');
        } else {
          this.submitButton?.removeAttribute('aria-disabled');
          this.syncSubmitLabel();
        }
      }

      async handleSubmit(event) {
        if (this.mode !== 'trio') return;

        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        const primary = this.getVariantByOption(this.getSelectedOption()) || this.getCurrentVariant();
        const variants = [
          primary,
          ...this.trioSelects.map((select) => this.variantMap.get(String(select.value))),
        ];

        const variantIds = variants.map((variant) => String(variant?.id || ''));
        if (
          variants.length !== 3
          || variants.some((variant) => !variant?.available)
          || new Set(variantIds).size !== 3
          || !Number.isFinite(this.wardrobeVariantId)
          || this.wardrobeVariantId <= 0
        ) {
          this.setStatus(this.dataset.errorLabel, true);
          return;
        }

        const displayNames = variants.map((variant) => variant.displayName || variant.option);

        const payload = {
          items: [{
            id: this.wardrobeVariantId,
            quantity: 1,
            properties: {
              [this.dataset.firstScentLabel || 'First scent']: displayNames[0],
              [this.dataset.secondScentLabel || 'Second scent']: displayNames[1],
              [this.dataset.thirdScentLabel || 'Third scent']: displayNames[2],
              '_Arabian Beard Oil variant IDs': variantIds.join(', '),
              '_Campaign': 'GCC Arabian Scent Wardrobe',
            },
          }],
        };

        this.setStatus('');
        this.setLoading(true);

        try {
          if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(document.activeElement);
            }
          }

          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Unable to add the Beard Oil trio.');
          }

          if (this.cart && typeof this.cart.renderContents === 'function' && data.sections) {
            if (!data.key && Array.isArray(data.items) && data.items[0]?.key) {
              data.key = data.items[0].key;
            }
            this.cart.classList.remove('is-empty');
            this.cart.renderContents(data);
          } else {
            window.location.href = window.routes.cart_url;
            return;
          }

          this.setStatus(this.dataset.successLabel);
        } catch (error) {
          console.error(error);
          this.setStatus(this.dataset.errorLabel, true);
        } finally {
          this.setLoading(false);
        }
      }
    }
  );
})();
